import { create } from 'zustand'

export interface PreviewImageItem {
  url: string
  rotate?: number
}

interface ImagePreviewState {
  visible: boolean
  images: PreviewImageItem[]
  current: number
  open: (images: PreviewImageItem[] | PreviewImageItem | string[] | string, current?: number) => void
  close: () => void
  setCurrent: (current: number) => void
}

const normalizeImages = (
  images: PreviewImageItem[] | PreviewImageItem | string[] | string,
): PreviewImageItem[] => {
  const list = Array.isArray(images) ? images : [images]

  return list.flatMap((item) => {
    if (typeof item === 'string') {
      const url = item.trim()
      return url ? [{ url }] : []
    }

    if (item && typeof item.url === 'string') {
      const url = item.url.trim()
      return url ? [{ ...item, url }] : []
    }

    return []
  })
}

export const useImagePreviewStore = create<ImagePreviewState>((set) => ({
  visible: false,
  images: [],
  current: 0,
  open: (images, current = 0) => {
    const normalizedImages = normalizeImages(images)
    if (normalizedImages.length === 0) {
      return
    }

    const safeCurrent = Math.min(Math.max(current, 0), normalizedImages.length - 1)
    set({
      visible: true,
      images: normalizedImages,
      current: safeCurrent,
    })
  },
  close: () => set({ visible: false, images: [], current: 0 }),
  setCurrent: (current) => set((state) => ({
    current: Math.min(Math.max(current, 0), Math.max(state.images.length - 1, 0)),
  })),
}))

export const openGlobalImagePreview = (
  images: PreviewImageItem[] | PreviewImageItem | string[] | string,
  current = 0,
) => {
  useImagePreviewStore.getState().open(images, current)
}

export const closeGlobalImagePreview = () => {
  useImagePreviewStore.getState().close()
}
